import { SymbolType } from '@shared/types/tsk';

/**
 * Project-wide master mapping for symbol acronyms.
 * Ensures 100% synchronization between Editor UI and PDF Reports.
 */
export const SYMBOL_ACRONYMS: Record<SymbolType, string> = {
  // Fixtures
  [SymbolType.WC]: 'WC',
  [SymbolType.BASIN]: 'B',
  [SymbolType.SINK]: 'SNK',
  [SymbolType.SHOWER]: 'SHR',
  [SymbolType.BATH]: 'BTH',
  [SymbolType.WASHING_MACHINE]: 'WM',
  [SymbolType.DISHWASHER]: 'DW',
  [SymbolType.LAUNDRY_TUB]: 'LT',
  [SymbolType.FLOOR_WASTE]: 'FW',
  [SymbolType.TUNDISH]: 'TD',

  // Fittings
  [SymbolType.IO]: 'IO',
  [SymbolType.IOS]: 'IOS',
  [SymbolType.CO]: 'CO',
  [SymbolType.COS]: 'COS',
  [SymbolType.ORG]: 'ORG',
  [SymbolType.SWIVEL_JOINT]: 'SWIV',
  [SymbolType.EXPANSION_JOINT]: 'EXP',

  // Directional
  [SymbolType.RISER]: 'R',
  [SymbolType.DROPPER]: 'D'
};

/**
 * Returns the professional shorthand acronym for a given symbol type.
 */
export const getSymbolAcronym = (type: SymbolType): string => {
  return SYMBOL_ACRONYMS[type] || type.toString();
};

/**
 * Returns the full professional name for a given symbol type.
 * Syncs with GeminiPanel and ReportExportTemplate.
 */
export const getSymbolName = (type: SymbolType): string => {
  switch (type) {
    case SymbolType.WC: return 'Water Closet';
    case SymbolType.BASIN: return 'Basin';
    case SymbolType.SHOWER: return 'Shower';
    case SymbolType.SINK: return 'Sink';
    case SymbolType.BATH: return 'Bath';
    case SymbolType.WASHING_MACHINE: return 'Washing Machine';
    case SymbolType.DISHWASHER: return 'Dishwasher';
    case SymbolType.LAUNDRY_TUB: return 'Laundry Tub';
    case SymbolType.FLOOR_WASTE: return 'Floor Waste';
    case SymbolType.TUNDISH: return 'Tundish';
    case SymbolType.IO: return 'Inspection Opening';
    case SymbolType.IOS: return 'Inspection Opening Surface';
    case SymbolType.CO: return 'Cleaning Opening';
    case SymbolType.COS: return 'Cleaning Opening Surface';
    case SymbolType.ORG: return 'Overflow Relief Gully';
    case SymbolType.SWIVEL_JOINT: return 'Swivel Joint';
    case SymbolType.EXPANSION_JOINT: return 'Expansion Joint';
    case SymbolType.RISER: return 'Riser';
    case SymbolType.DROPPER: return 'Dropper';
    default: return (type as any).toString();
  }
};

